var map = {
	"./dc-arrow.jpg": 30,
	"./dc-batman.jpg": 31,
	"./dc-black.jpg": 32,
	"./dc-blue.jpg": 33,
	"./dc-flash.jpg": 34,
	"./dc-green.jpg": 35,
	"./dc-martian.jpg": 36,
	"./dc-robin.jpg": 37,
	"./dc-superman.jpg": 38,
	"./dc-wonder.jpg": 39,
	"./marvel-captain.jpg": 40,
	"./marvel-cyclops.jpg": 41,
	"./marvel-daredevil.jpg": 42,
	"./marvel-hawkeye.jpg": 43,
	"./marvel-hulk.jpg": 44,
	"./marvel-iron.jpg": 45,
	"./marvel-silver.jpg": 46,
	"./marvel-spider.jpg": 47,
	"./marvel-thor.jpg": 48,
	"./marvel-wolverine.jpg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;